export default {
  noFound: 'NoFound',
  login: 'Login',
  simpleLogin: 'SimpleLogin',
  countryPane: 'CountryPane',
  home: 'Home',
  eventDetail: 'EventDetail',
  newEvent: 'NewEvent',
  newEventDetail: 'NewEventDetail',
  selfInfo: 'SelfInfo',
  update: 'Update',
  preview: 'Preview',
  updateProfile: 'UpdateProfile',
  registeredEvents: 'RegisteredEvents',
  approvedEvents: 'ApprovedEvents',
  qrcode: 'QRcode',
  registerForm: 'RegisterForm',
  publicEvent: 'PublicEvent',
  survey: 'Survey',
  surveyNew: 'SurveyNew',
  surveyThanks: 'SurveyThanks',
  counselling: 'Counselling',
  video: 'Video',
  videoDetail: 'VideoDetail',
  apply: 'Apply',
  applyThanks: 'ApplyThanks',
  selfDiagnosis: 'SelfDiagnosis',
  internshipChallenge: 'InternshipChallenge',
  icAssistant: 'IcAssistant',
  share: 'Share',
  icTest: 'IcTest',
  pickClass: 'pickClass',
  coupon: 'Coupon',
  m: 'Mobile',
  statement: 'Statement',
  article: 'Article',
  articleDetail: 'ArticleDetail',
  menuList: 'MenuList',
  diagnosis: 'Diagnosis',
  careerProgrammes: 'CareerProgrammes',
  youPlusProgramme: 'YouPlusProgramme',
  youPlusAnchorPro: 'YouPlusAnchorPro',
  anchorDiscovery: 'AnchorDiscovery',
  anchorExplorer: 'AnchorExplorer',
  anchorChallenger: 'AnchorChallenger',
  wechat: 'Wechat',
  drawlots: 'Drawlots'
}
